import type { IMerchantAbstract } from "./Merchant";

export const MerchantQueryParamName = "me";

export type MerchantQueryParam = IMerchantAbstract | string;

export interface IMerchantContext {
  merchant?: MerchantQueryParam;
}
